/* src/modules/create_tutor/actions.js */

import { addTutorsTypes, CLEAR_ADDED_TUTORS } from './action_types';

import { makeMutation } from '../../config/client';
import { ADD_TUTORS_MUTATION } from './api';

export const addTutors = variables => makeMutation({ variables })(
  addTutorsTypes,
  ADD_TUTORS_MUTATION
);

export const clearAddedTutors = () => ({ type: CLEAR_ADDED_TUTORS });



// WEBPACK FOOTER //
// ./src/modules/create_tutor/actions.js